// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initIntegumentary: Object,
}

class EditIntegumentary extends Component<Props> {
  render() {
    const integumentary = this.props.initIntegumentary || {};
    return (
      <ContentBox title='Integumentary'>
        <div className={styles.col}>
          <PrimaryText>Skin Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <Checkbox field='integumentary.parameters' initialValue={integumentary.parameters} />Within expected parameters for patient<br />
            <Checkbox field='integumentary.rash' initialValue={integumentary.rash} />Rash<br />
            <Checkbox field='integumentary.pale' initialValue={integumentary.pale} />Pale<br />
            <Checkbox field='integumentary.flushed' initialValue={integumentary.flushed} />Flushed<br />
            <Checkbox field='integumentary.cyanotic' initialValue={integumentary.cyanotic} />Cyanotic<br />
            <Checkbox field='integumentary.jaundice' initialValue={integumentary.jaundice} />Jaundice<br />
            <Checkbox field='integumentary.dusky' initialValue={integumentary.dusky} />Dusky<br />
            <Checkbox field='integumentary.mottled' initialValue={integumentary.mottled} />Mottled<br />
            <Checkbox field='integumentary.erythema' initialValue={integumentary.erythema} />Erythema<br />
            <Checkbox field='integumentary.pigmentChange' initialValue={integumentary.pigmentChange} />Pigment change<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Temperature:</SecondaryText><br />
            <Checkbox field='integumentary.warm' initialValue={integumentary.warm} />Warm<br />
            <Checkbox field='integumentary.cool' initialValue={integumentary.cool} />Cool<br />
            <Checkbox field='integumentary.coldExtremes' initialValue={integumentary.coldExtremes} />Cold extremities<br />
            <Checkbox field='integumentary.coldCore' initialValue={integumentary.coldCore} />Cold core<br />
            <Checkbox field='integumentary.hot' initialValue={integumentary.hot} />Hot
          </div>
          <div className={styles.section}>
            <SecondaryText>Skin turgor:</SecondaryText><br />
            <Checkbox field='integumentary.goodElastic' initialValue={integumentary.goodElastic} />Good elasticity<br />
            <Checkbox field='integumentary.poorElastic' initialValue={integumentary.poorElastic} />Poor elasticity<br />
            <Checkbox field='integumentary.fragile' initialValue={integumentary.fragile} />Fragile<br />
            <Checkbox field='integumentary.tenting' initialValue={integumentary.tenting} />Tenting<br />
            <Checkbox field='integumentary.edema' initialValue={integumentary.edema} />Edema (see Cardiovascular Assessment)
          </div>
          <div className={styles.section}>
            <SecondaryText>Integrity:</SecondaryText><br />
            <Checkbox field='integumentary.intact' initialValue={integumentary.intact} />Intact skin, no lesions<br />
            <Checkbox field='integumentary.fragileInt' initialValue={integumentary.fragileInt} />Fragile integrity, tears easily<br />
            <Checkbox field='integumentary.wound' initialValue={integumentary.wound} />Surgical wound<br />
            <Checkbox field='integumentary.pressureUlcer' initialValue={integumentary.pressureUlcer} />Pressure ulcer
          </div>
          <div className={styles.section}>
            <SecondaryText>Moisture:</SecondaryText><br />
            <Checkbox field='integumentary.moist' initialValue={integumentary.moist} />Moist<br />
            <Checkbox field='integumentary.dry' initialValue={integumentary.dry} />Dry<br />
            <Checkbox field='integumentary.diaphoretic' initialValue={integumentary.diaphoretic} />Diaphoretic<br />
            <Checkbox field='integumentary.clammy' initialValue={integumentary.clammy} />Clammy
          </div>
          <div className={styles.section}>
            <SecondaryText>Skin Notes:</SecondaryText><br />
            <TextArea field='integumentary.skinNotes' initialValue={integumentary.skinNotes} />
          </div>
          <PrimaryText>Hair Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Distribution:</SecondaryText><br />
            <Checkbox field='integumentary.expectedDist' initialValue={integumentary.expectedDist} />Expected for sex<br />
            <Checkbox field='integumentary.unexpectedDist' initialValue={integumentary.unexpectedDist} />Unexpected for sex
          </div>
          <div className={styles.section}>
            <SecondaryText>Characteristics:</SecondaryText><br />
            <Checkbox field='integumentary.expectedChar' initialValue={integumentary.expectedChar} />Expected hair throughout<br />
            <Checkbox field='integumentary.overabundance' initialValue={integumentary.overabundance} />Overabundance<br />
            <Checkbox field='integumentary.alopeciaGen' initialValue={integumentary.alopeciaGen} />Alopecia, generalized<br />
            <Checkbox field='integumentary.alopeciaSingle' initialValue={integumentary.alopeciaSingle} />Alopecia, single area<br />
            <Checkbox field='integumentary.thinning' initialValue={integumentary.thinning} />Thinning
          </div>
          <div className={styles.section}>
            <SecondaryText>Health:</SecondaryText><br />
            <Checkbox field='integumentary.dryHair' initialValue={integumentary.dryHair} />Dry, brittle<br />
            <Checkbox field='integumentary.dyed' initialValue={integumentary.dyed} />Dyed<br />
            <Checkbox field='integumentary.nits' initialValue={integumentary.nits} />Nits<br />
            <Checkbox field='integumentary.healthyHair' initialValue={integumentary.healthyHair} />Healthy
          </div>
          <div className={styles.section}>
            <SecondaryText>Hair notes:</SecondaryText><br />
            <TextArea field='integumentary.hairNotes' initialValue={integumentary.hairNotes} />
          </div>
          <PrimaryText>Nail Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Configuration:</SecondaryText><br />
            <Checkbox field='integumentary.smooth' initialValue={integumentary.smooth} />Smooth and intact<br />
            <Checkbox field='integumentary.pitting' initialValue={integumentary.pitting} />Pitting<br />
            <Checkbox field='integumentary.pulling' initialValue={integumentary.pulling} />Pulling from nailbed
          </div>
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <Checkbox field='integumentary.pink' initialValue={integumentary.pink} />Pink<br />
            <Checkbox field='integumentary.yellow' initialValue={integumentary.yellow} />Yellow discoloration<br />
            <Checkbox field='integumentary.whiteSpots' initialValue={integumentary.whiteSpots} />White spots<br />
            <Checkbox field='integumentary.pigmentedLines' initialValue={integumentary.pigmentedLines} />Pigmented lines
          </div>
          <div className={styles.section}>
            <SecondaryText>Condition:</SecondaryText><br />
            <Checkbox field='integumentary.healthyNails' initialValue={integumentary.healthyNails} />Healthy appearance, well groomed<br />
            <Checkbox field='integumentary.ingrown' initialValue={integumentary.ingrown} />Ingrown nail (describe in Notes)<br />
            <Checkbox field='integumentary.nailTrauma' initialValue={integumentary.nailTrauma} />Nail trauma (describe in Notes)<br />
            <Checkbox field='integumentary.otherNailCond' initialValue={integumentary.otherNailCond} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>Nail base:</SecondaryText><br />
            <Checkbox field='integumentary.flatSmooth' initialValue={integumentary.flatSmooth} />Flat and smooth<br />
            <Checkbox field='integumentary.ridged' initialValue={integumentary.ridged} />Ridged<br />
            <Checkbox field='integumentary.spooning' initialValue={integumentary.spooning} />Spooning<br />
            <Checkbox field='integumentary.clubbing' initialValue={integumentary.clubbing} />Clubbing (greater than 180 degrees)<br />
            <Checkbox field='integumentary.transverseGroove' initialValue={integumentary.transverseGroove} />Transverse grooving<br />
            <Checkbox field='integumentary.paronychia' initialValue={integumentary.paronychia} />PParonychia<br />
            <Checkbox field='integumentary.splinter' initialValue={integumentary.splinter} />Splinter hemorrhages<br />
            <Checkbox field='integumentary.infection' initialValue={integumentary.infection} />Infection<br />
            <Checkbox field='integumentary.otherNailBase' initialValue={integumentary.otherNailBase} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>Nail notes:</SecondaryText><br />
            <TextArea field='integumentary.nailNotes' initialValue={integumentary.nailNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditIntegumentary;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditIntegumentary.jsx